export default {
  speciesLoading: false,
  species: [],
  predefinedSpeciesLoading: false,
  predefinedSpecies: []
}
